export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            了解51爆料吃瓜网的故事
          </p>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10 text-left">
            <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-950">51爆料</strong>成立于2024年，是国内领先的娱乐资讯聚合平台。
                我们以"全网吃瓜第一站"为定位，致力于为吃瓜群众提供最新、最全、最快的爆料资讯服务。
              </p>
              <p>
                平台每日追踪娱乐圈八卦、网红动态、社会热点、影视争议等内容，覆盖微博、抖音、小红书、B站等100+主流社交平台。
                通过自研的热度算法和人工编辑双重审核机制，确保每一条爆料都经过严格筛选，为用户呈现最有价值的吃瓜内容。
              </p>
              <p>
                目前，51爆料日均更新200+条爆料，月活跃用户超过50万。我们始终坚持"快、全、准"的运营理念，
                打造开放、及时的资讯聚合平台，让每一位吃瓜群众都能在这里找到自己关心的热点内容。
              </p>
              <p>
                如果你有独家爆料线索，欢迎通过投稿邮箱 tougao@51baoliao.com 与我们联系。
                51爆料，让你永远走在吃瓜第一线。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-600">200+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">100+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖平台</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-600">8大</div>
                <div className="text-xs text-foreground-500 mt-1">内容分类</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}